/**
 * NLB-GW
 *
 * Contact: service@rheinenergie.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * maps contract consumption per division
 */
export interface ContractConsumptionDetails { 
    /**
     * accountId of existing contract, also knows as VK
     */
    accountId?: string;
    /**
     * division of product e.g. S4 for power, G6 for gas or T4 for water
     */
    divisionId?: string;
    consumption?: number;
    chargingConsumption?: number;
}

